import { useQuery, QueryHookOptions } from '@apollo/client'

import { useRestaurant } from '@local/do-secundo-restaurant-provider'

import { GET_PROMO_BANNERS } from '../apollo'
import { LoyaltyBanner, PromoCodeBanner } from '../@types'

type PromoBannerInput = {
  input: {
    restaurantGuid: string
  }
}

type PromoBannerResponse = {
  promoBanners: {
    banners: PromoCodeBanner[] // @deprecated field
    promoCodeBanners: PromoCodeBanner[]
    loyaltyBanners: LoyaltyBanner[]
  }
}

type GetPromoBannerQueryOptions = QueryHookOptions<
  PromoBannerResponse,
  PromoBannerInput
>

export const useGetPromoBanners = (
  queryOptions: GetPromoBannerQueryOptions = {}
) => {
  const { restaurantGuid } = useRestaurant()

  return useQuery<PromoBannerResponse, PromoBannerInput>(GET_PROMO_BANNERS, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        restaurantGuid
      }
    },
    ...queryOptions
  })
}
